import React, { useEffect, useState } from 'react';
import { translate } from "../Services/translation";

const FogsandCalculator = ({
    fogFactor,
    setQuantityState,
    minFogWidth,
    maxFogWidth,
    minTileThickness,
    maxTileThickness,
    sackWeight,
    belowMinFogWidth,
    aboveMaxFogWidth,
    belowMinTileThickness,
    aboveMaxTileThickness,
}) => {
    const [tileWidth, setTileWidth] = useState(null);
    const [tileLength, setTileLength] = useState(null);
    const [tileThickness, setTileThickness] = useState(null);
    const [area, setArea] = useState(null);
    const [fogWidth, setFogWidth] = useState(null);

    const [fogWidthTooBig, setFogWidthTooBig] = useState(false);
    const [fogWidthTooSmall, setFogWidthTooSmall] = useState(false);
    const [thicknessTooBig, setThicknessTooBig] = useState(false);
    const [thicknessTooSmall, setThicknessTooSmall] = useState(false);


    function toggleCalculator() {
        let clickFlag = false;
        var clickedButton = document.getElementById('calculateFogsandButton');
        var accordionContent = document.getElementById('fogsandContainer')
        clickFlag = true;
        accordionContent.classList.toggle('active');
        clickedButton.classList.toggle('active');
        setTimeout(() => {
            clickFlag = false;
        }, 300);
    }

    function checkKeyDown(event) {
        return ["e", "E", "+", "-"].includes(event.key) && event.preventDefault();
    }

    function validateTileThickness(number) {
        setTileThickness(number);
        if(number < minTileThickness) {
            setThicknessTooSmall(true);
            setThicknessTooBig(false);
        } else if(number > maxTileThickness) {
            setThicknessTooBig(true);
            setThicknessTooSmall(false);
        } else {
            setThicknessTooSmall(false);
            setThicknessTooBig(false);
        }
    }

    function validateFogWidth(number) {
        setFogWidth(number);
        if(number < minFogWidth) {
            setFogWidthTooSmall(true);
            setFogWidthTooBig(false);
        } else if(number > maxFogWidth) {
            setFogWidthTooBig(true);
            setFogWidthTooSmall(false);
        } else {
            setFogWidthTooSmall(false);
            setFogWidthTooBig(false);
        }
    }

    useEffect(() => {
        if(tileWidth && tileLength && tileThickness && fogWidth && area) {
            if(!(thicknessTooSmall|| thicknessTooBig || fogWidthTooSmall || fogWidthTooBig)) {
                setTileWidth(parseFloat(tileWidth));
                setTileLength(parseFloat(tileLength));
                setTileThickness(parseFloat(tileThickness));
                setFogWidth(parseFloat(fogWidth));
                setArea(parseFloat(area));
                let weightPerSquaremeter = (1/(tileWidth + fogWidth) + 1/(tileLength + fogWidth))*fogWidth*tileThickness*1.29;
                let weightForWholeArea = weightPerSquaremeter * fogFactor * area;
                let amountOfSacks = Math.ceil(weightForWholeArea/sackWeight);
                setQuantityState(amountOfSacks);
            }
        }
    }, [tileWidth, tileLength, tileThickness, fogWidth, area])

    return (
        <div>
            <h4 class="fogsand__border" id="calculateFogsandButton" onClick={toggleCalculator}>{translate("fogcalculator.open")}</h4>
            <div className='fogsand__container' id="fogsandContainer">
                <div className='fogsand__row'>
                    <div className='fogsand__row__group'>
                        <label className='fogsand__header' for="test">{translate("fogcalculator.tiledimensions")}</label>
                        <label id="test" for="tilewidth">{translate("fogcalculator.tilewidth")}</label>
                        <input 
                            type='number' 
                            id='tilewidth' 
                            min={0} 
                            onChange={(event) => setTileWidth(event.target.value)} 
                            onKeyDown={(event) => checkKeyDown(event)}>
                        </input>
                    </div>
                    <div className='fogsand__row__group'>
                        <label for="tilelength">{translate("fogcalculator.tilelength")}</label>
                        <input 
                            type='number' 
                            id='tilelength'
                            min={0}  
                            onChange={(event) => setTileLength(parseFloat(event.target.value))}
                            onKeyDown={(event) => checkKeyDown(event)}>
                        </input>
                    </div>
                    <div className='fogsand__row__group'>
                        <label for='tilethickness'>{translate("fogcalculator.tilethickness")}</label>
                        <input 
                            type='number' 
                            id='tilethickness'
                            min={minTileThickness}
                            max={maxTileThickness}
                            className={(thicknessTooBig || thicknessTooSmall) ? "fogsand__redborder": ""}  
                            onChange={(event) => validateTileThickness(parseFloat(event.target.value))}
                            onKeyDown={(event) => checkKeyDown(event)}>
                        </input>
                    </div>
                </div>
                <div className='fogsand__row'>
                    <div className='fogsand__row__group'>
                        <label className='fogsand__header' for="test1">{translate("fogcalculator.othermeasurements")}</label>
                        <label id="test1" for="fogwidth">{translate("fogcalculator.fogwidth")}</label>
                        <input 
                            type='number' 
                            id='fogwidth'
                            className={(fogWidthTooBig || fogWidthTooSmall) ? "fogsand__redborder": ""}
                            min={minFogWidth}
                            max={maxFogWidth}  
                            onChange={(event) => validateFogWidth(parseFloat(event.target.value))}
                            onKeyDown={(event) => checkKeyDown(event)}>
                        </input>
                    </div>
                    <div className='fogsand__row__group'>
                        <label for='area'>{translate("fogcalculator.area")}</label>
                        <input 
                            type='number' 
                            id='area'
                            min={0} 
                            onChange={(event) => setArea(parseFloat(event.target.value))}
                            onKeyDown={(event) => checkKeyDown(event)}>
                        </input>
                    </div>
                    <button className='button' onClick={toggleCalculator}>{translate("fogcalculator.close")}</button>
                </div>
                <div className='fogsand__description'>
                    <h5>{translate("fogcalculator.description")}</h5>
                </div>
                {(fogWidthTooBig) && (
                    <div className='fogsand__error' dangerouslySetInnerHTML={{__html: aboveMaxFogWidth}}/>
                )}
                {(thicknessTooBig) && (
                    <div className='fogsand__error' dangerouslySetInnerHTML={{__html: aboveMaxTileThickness}}/>
                )}
                {(fogWidthTooSmall) && (
                    <div className='fogsand__error' dangerouslySetInnerHTML={{__html: belowMinFogWidth}}/>
                )}
                {(thicknessTooSmall) && (
                    <div className='fogsand__error' dangerouslySetInnerHTML={{__html: belowMinTileThickness}}/>
                )}
            </div>
        </div>
    )
};

export default FogsandCalculator;